module.exports = __webpack_public_path__ + "assets/img/44@3x.11d40a5e.png";